import PropTypes from 'prop-types'

import {
  TextField as MUITextField,
  InputAdornment,
  IconButton,
} from '@mui/material'
import { ReactComponent as X } from '../../../assets/icons/x.svg'

const TextField = ({ name, label, value, onChange, notClearable }) => {
  return (
    <MUITextField
      type="text"
      name={name}
      label={label}
      onChange={e => onChange(e.target.value)}
      value={value}
      InputProps={{
        endAdornment: !notClearable && value !== '' && (
          <InputAdornment position="end">
            <IconButton
              onClick={() => onChange('')}
              onMouseDown={e => e.preventDefault()}
            >
              <X />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

TextField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  notClearable: PropTypes.bool,
}

export default TextField
